import React, { useEffect } from "react";

import { useTraslados } from "../../../hooks/useCases/useTraslados";
import { useStylesMUI } from "../../../styles/home/style";
import { TemplateABM } from "../../atomic/templates/TemplateABM";
import { SelectValidatorGeneric } from "../../atomic/atoms/Select";
import { required } from "../../../helpers/validations/validators";
import { GCheckbox } from "../../atomic/atoms/GCheckbox";

export const TipoDocumentacionSolicitudTraslados = () => {
    const classes = useStylesMUI();
    const { data, get, post, put, remove, permisos } = useTraslados();

    useEffect(() => { 
        get.autorizaciones.tipoDocumentacion();
        get.tipoDocSolicitudes(); 
    }, []);    

    return (
        <div className={classes.root}>
            <TemplateABM
                without={{
                    insert: !permisos.configuracion.alta,
                    delete: !permisos.configuracion.baja,
                    update: !permisos.configuracion.modificar,
                }}
                titles={{
                    abm: 'Tipo Documentación Solicitudes Traslados',
                    insert: 'Agregar Tipo Documentación Solicitud',
                    update: 'Modificar Tipo Documentación Solicitud',
                    delete: 'Eliminar Tipo Documentación Solicitud',
                }}
                data={(data) => ({
                    id: data?.id || '',
                    idTipoDoc: data?.idTipoDoc || '',
                    obligatorio: data?.obligatorio || false,
                })}
                formStructure={({ formValues, handleInputChange, setearValor }) => [
                    {
                        Component: SelectValidatorGeneric,
                        label: 'Tipo Documentación',
                        name: 'idTipoDoc',
                        value: formValues.idTipoDoc,
                        onChange: handleInputChange,
                        validations: [required],
                        grid: { xs: 12, md: 8 },
                        menuItems: data.autorizaciones.tipoDocumentacion.map((item) => ({
                          value: item.idTipoDoc,
                          label: item.descripcion,
                        })),
                      },
                    {
                        Component: GCheckbox,
                        value: formValues.obligatorio,
                        onChange: () => setearValor("obligatorio", !formValues.obligatorio),
                        label: "Obligatorio",
                        grid: { xs: 12, md: 4 },
                    }
                ]}
                dataTable={{
                    list: data.tipoDocSolicitudes,
                    columns: [
                        {
                            label: 'Tipo Documentación',
                            customBody: (item) => item?.tipoDocumentacion?.descripcion,
                        },
                        {
                            label: 'Obligatorio',
                            customBody: (item) => (
                                <GCheckbox 
                                    value={item.obligatorio}
                                    onChange={() => {
                                        const newValues = {
                                            ...item, obligatorio: !item.obligatorio
                                        };
                                        put.tipoDocSolicitudes(newValues)}}
                                />
                            )
                        }
                    ],
                }}
                submit={(formValues, handleClose) => {
                    if(formValues.id) put.tipoDocSolicitudes(formValues)
                    else post.tipoDocSolicitudes(formValues);
                    handleClose();
                }}
                deleteButton={(id, handleClose) => {
                    remove.tipoDocSolicitudes(id);
                    handleClose();
                }}
            />
        </div>
    );
};